/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recommended_Profile_PlaceholderInputs */

const en_recommended_profile_placeholder = /** @type {(inputs: Recommended_Profile_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended roast profile...`)
};

const es_recommended_profile_placeholder = /** @type {(inputs: Recommended_Profile_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil de tueste recomendado...`)
};

/**
* | output |
* | --- |
* | "Recommended roast profile..." |
*
* @param {Recommended_Profile_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const recommended_profile_placeholder = /** @type {((inputs?: Recommended_Profile_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recommended_Profile_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recommended_profile_placeholder(inputs)
	return es_recommended_profile_placeholder(inputs)
});